export default "__VITE_ASSET__DhokliRi__"